import React from "react";
import Loader from "../common/loader";

function Auth() {
  return (
    <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center text-center p-3">
      <Loader />
      <h3 className="mt-2">Authorization check in progress...</h3>
    </div>
  );
}

export default Auth;
